<template lang="pug">
  transition(name="modal")
    .modal.fixed.z-100.inset-0.flex.justify-center.items-center(v-if="value")
      .cover(@click="$emit('input', false)")
      .content
        .relative.h-full.mx-auto.flex.flex-col.justify-center.items-center
          img(alt="" :src="extra.imageSrc")
          h2.my-6.text-lg {{extra.name}}
          p.mx-auto.max-w-xl.text-center(v-html="formatTohtml(extra.description)")
</template>
<style lang="sass" scoped>
.cover
  @apply absolute inset-0 bg-white opacity-75
.content
  ::v-deep
    span
      @apply inline-block
  @apply text-black relative max-w-screen-sm mx-auto py-4 w-10/12
  height: 62.5vh
  max-height: 35rem
  @screen ls
    @apply max-w-screen-lg
    max-height: 24rem
    height: 50vh
    min-height: 18rem
  @screen lg
    @apply mb-16
  img
    max-height: 50vh
</style>
<script>
export default {
  props: ["value", "extra"]
};
</script>
